<template>
  <v-container>
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        ref="form"
        autocomplete="no"
      >
        <page-title
          icon="mdi-pencil-box-outline"
          main="Sic e Ouvidoria"
          sub="Lista cadastro de pessoas"
          home="/home-sic"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código do pedido"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            <v-text-field
              v-model="nome"
              label="Solicitante"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="justify-end">
        <v-btn
          color="indigo"
          dark
          class="mr-4"
          :href="urlRel"
          target="_blank"
        >
          <v-icon left>
            mdi-printer
          </v-icon>
          Impimir
        </v-btn>
        <v-btn
          color="secondary"
          class="mr-4"
          @click="reset"
        >
          <v-icon left>
            mdi-broom
          </v-icon>
          Limpar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar pedidos de auxílio
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headersFt"
              :items="filtro"
              item-key="id"
              :search="search"
              dense
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadPedidoFilter(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadPedidoFilter(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '../../../components/template/PageTitle.vue'
import axios from 'axios'
import { baseApiUrl, baseApiRel } from '@/global'
import moment from 'moment'
export default {
  components: { PageTitle },
  name: 'ListaCadastro',
  data: () => ({
    codigo: '',
    nome: '',
    dialog: false,
    id: '',
    search: '',
    urlRel: '',
    filtro: [],
    headersFt: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Cpf / Cnpj', value: 'cgc' },
      { text: 'Solicitante', value: 'solicitante' },
      { text: 'Data do pedido', value: 'dataP' },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadFiltro () {
      const url = `${baseApiUrl}/adm-adm-filtro`
      axios.get(url).then(res => {
        this.filtro = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm')
          }
        })
      })
    },
    loadPedidoFilter (filtro) {
      this.codigo = filtro.id
      this.nome = filtro.solicitante
      const idRel = filtro.id
      if (idRel) {
        this.urlRel = `${baseApiRel}/rel-lista-beneficios-id/${idRel}`
      }
      this.dialog = false
    },
    reset () {
      this.codigo = ''
      this.idRel = ''
      this.urlRel = `${baseApiRel}/rel-lista-beneficios`
    }
  },
  mounted () {
    this.filtro.id = ''
    this.urlRel = `${baseApiRel}/rel-lista-beneficios`
  }
}
</script>
